import DatabaseSimpleView from './DatabaseSimpleView'

export default DatabaseSimpleView
